import { mapPermissionSetResourceToProps } from '@/features/iam/permissions/permission-mappers'
import { type TeamRoleResource } from '@/features/iam/api/resources/team-role'
import { type TeamRoleProps } from '@/features/iam/teams/TeamRole'

export function mapTeamRoleResourceToProps(
  resource: Partial<TeamRoleResource>,
): Partial<TeamRoleProps> {
  return {
    id: resource.id,
    isOwnerRole: resource.is_owner_role,
    name: resource.name,
    description: resource.description,
    permissions:
      resource.permissions &&
      mapPermissionSetResourceToProps(resource.permissions),
    workspaceId: resource.workspace_id,
  }
}
